const Divider = () => {
    return (
      <hr
        className="my-20 h-[2px] border-t-0 bg-transparent bg-gradient-to-r from-transparent via-neutral-800 to-transparent opacity-25 dark:opacity-100"
      />
    );
}

export default Divider;